import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPlusCircle,
	faTrashAlt,
	faExternalLinkAlt,
	faStarHalfStroke,
	faPenClip,
	faFilter,
	faClose,
	faCheck,
	faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

import { faBlackTie } from '@fortawesome/free-brands-svg-icons'

import Loader from '@/components/Loader/index.vue'
import UserCard from '@/components/UserCard/index.vue'
import api from '@/helpers/fetch'
import { genId } from '@/helpers/gen-id'

library.add(
	faPlusCircle,
	faExternalLinkAlt,
	faTrashAlt,
	faStarHalfStroke,
	faPenClip,
	faBlackTie,
	faFilter,
	faClose,
	faCheck,
	faChevronDown,
)

@Component({
	components: {
		Loader,
		UserCard,
	},
})
export default class Permissions extends Vue {
	loading = false;
	loadingGroup = false;
	location = window.location;
	usersList = [] as Array<any>;
	assetsList = [] as Array<any>;

	filters = {
		elaborator: '',
		sales: '',
		reviewer: '',
	};

	form = {
		group: '',
		name: '',
		id: '',
	};

	selectedRole = [] as Array<any>;

	options = {
		groups: [] as Array<any>,
	};

	newForm = {
		name: '',
		id: '',
	};

	fields = [
		{
			key: 'asset',
			formatter: (asset) => asset.name,
			label: 'Recurso',
			thClass: 'text-center w-50',
		},
		{
			key: 'create',
			label: 'Criar',
			thClass: 'text-center',
			tdClass: 'm-0 p-0 align-middle text-center ',
		},
		{
			key: 'edit',
			label: 'Editar',
			thClass: 'text-center',
			tdClass: 'm-0 p-0 align-middle text-center ',
		},
		{
			key: 'delete',
			label: 'Deletar',
			thClass: 'text-center',
			tdClass: 'm-0 p-0 align-middle text-center ',
		},
		{
			key: 'view',
			label: 'Visualizar',
			thClass: 'text-center',
			tdClass: 'm-0 p-0 align-middle text-center ',
		}
	];

	savingNewGroup = false;

	async mounted() {
		this.loading = true;
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath);
		const res = await api.get('/api/permissions/assets');
		this.assetsList.length = 0;
		this.assetsList.push(...res.data);
		this.loadRoles();
	}

	async loadRoles() {
		this.loading = true;
		const res = await api.get('/api/permissions/roles');
		this.options.groups.length = 0;
		this.options.groups.push(...res.data);
		this.loading = false;
	}

	resetForms() {
		this.form.name = '';
		this.form.id = '';
		this.selectedRole = [];
		this.newForm.name = '';
		this.newForm.id = '';
	}

	async deleteRole() {
		if (!this.form.id) return;
		this.loading = true;
		const res = await api.delete('/api/permissions/roles/' + this.form.id, {});
		this.loadRoles();
		this.resetForms();
		this.loading = false;
	}

	async createGroup() {
		this.savingNewGroup = true;
		const res = await api.post('/api/permissions/roles', this.newForm);
		this.$bvModal.hide('modal-novo-grupo');
		this.loadRoles();
		this.resetForms();
		this.savingNewGroup = false;
	}

	async removeAllow(data) {
		data.value.loading = true;
		const res = await api.post('/api/permissions/roles/' + this.form.id + '/removePermissions', { resource: data.item.asset.key, permissions: data.field.key });
		if (res.ok) data.value.value = false;
		data.value.loading = false;
	}

	async allow(data) {
		data.value.loading = true;
		const res = await api.post('/api/permissions/roles/' + this.form.id + '/addPermissions', { resource: data.item.asset.key, permissions: data.field.key });
		if (res.ok) data.value.value = true;
		data.value.loading = false;
	}

	async getRole() {
		if (!this.form.id) return;
		this.loadingGroup = true;
		const res = await api.get('/api/permissions/roles/' + this.form.id);

		this.selectedRole = res.data.map((item) => {
			const parsed = {
				asset: item.key.replace('allows_', '')
			};

			const permissions = JSON.parse(item.value);
			const temp = {
				create: {
					loading: false,
					value: false,
				},
				edit: {
					loading: false,
					value: false,
				},
				delete: {
					loading: false,
					value: false,
				},
				view: {
					loading: false,
					value: false,
				},
			};
			for (let i = 0; i < permissions[this.form.id].length; i++) {
				temp[permissions[this.form.id][i]].value = true;
			}
			return Object.assign(parsed, temp);
		});
		this.loadingGroup = false;
	}

	get itemsMatch() {
		if (!this.form.id) return [];
		// constroi tabela com todos os valores iguais a 'false'
		const items = [] as Array<any>;
		for (let i = 0; this.assetsList.length > i; i++) {
			items.push({
				asset: this.assetsList[i],
				rowHtmlId: genId(),
				create: {
					loading: false,
					value: false,
				},
				edit: {
					loading: false,
					value: false,
				},
				delete: {
					loading: false,
					value: false,
				},
				view: {
					loading: false,
					value: false,
				},
			});
		}

		return items.map((row) => {
			this.selectedRole.forEach((allowed) => {
				if (row.asset.key === allowed.asset) {
					allowed.asset = row.asset;
					Object.assign(row, allowed);
				}
			})

			return row;
		});
	}

	updateId() {
		this.newForm.id = this.newForm.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, '').replace(/ /ig, '-').toLowerCase();
	}
}
